module.exports = __webpack_public_path__ + "static/media/ekspertspil.bb037fd6.svg";